import { render, staticRenderFns } from "./cadastro_novo_paciente.vue?vue&type=template&id=a95c5e48&scoped=true&"
import script from "./cadastro_novo_paciente.vue?vue&type=script&lang=js&"
export * from "./cadastro_novo_paciente.vue?vue&type=script&lang=js&"
import style0 from "./cadastro_novo_paciente.vue?vue&type=style&index=0&id=a95c5e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95c5e48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDialog,VProgressCircular,VRadio,VRadioGroup,VRow,VTextField,VTextarea})
